import Splide from '@splidejs/splide';
import '../../../../../../../../../node_modules/@splidejs/splide/dist/css/splide.min.css';

export default class PostSlider {
  constructor() {
    this.postSliders = document.querySelectorAll('.post-slider .splide');

    this.postSliders.forEach((postSlider) => {
      new Splide(postSlider, {
        pagination: false,
        arrows: true,
        autoWidth: true,
      }).mount();
    });
  }
}
